import z from 'zod';

export const DateFilterOperatorSchema = z.object({
  $gt: z.string().optional(),
  $gte: z.string().optional(),
  $lt: z.string().optional(),
  $lte: z.string().optional(),
}).refine(value => Object.keys(value).length > 0, {
  message: 'At least one date filter operator is required',
});

export const SortOrder = {
  ASC: 'asc',
  DESC: 'desc',
} as const;

/**
 * Zod schema for a sort direction in list params, e.g. `sort: { createdAt: 'desc' }`.
 */
export const SortOrderSchema = z.nativeEnum(SortOrder);
